import type { AllRouteEndpoints } from "../routeTypes";
export const appsCatalogsCatalogIdCacheKeys: AllRouteEndpoints[] = [
  "/apps/app_groups_using_catalogs",
  "/apps/catalogs",
  "/apps/catalogs_datatable",
  "/apps/catalogs_usage",
];
export const appsCatalogsCatalogId = "/apps/catalogs/:catalog_id";
